module.exports = __webpack_public_path__ + "static/media/Net Zero.cb89e2ea.svg";